<!--
 * @Description: 
 * @Date: 2021-02-05 23:41:15
-->
<template>
  <div class="living-before">
    <img class="living-before__pic" :src="livingStore.detail.videoPicUrl" />
    <template v-if="isShowCountdown">
      <!-- 顶部样式 -->
      <div class="living-before__top" v-if="countdownPosition === 1">
        <p>{{ videoPlaceholder }}</p>
        <ul>
          <li v-for="(item, index) in timeList" :key="index">
            <span>{{ item.time }}</span>
            <span>{{ item.suf }}</span>
          </li>
        </ul>
      </div>
      <!-- 全屏样式 -->
      <div class="living-before__full" v-if="countdownPosition === 2">
        <div class="living-before__mid">
          <div class="living-before__top2">
            <span>{{ videoPlaceholder }}</span>
            <span v-if="timeList[0] && timeList[0] !== '00'">
              {{ timeList[0].time === '00' ? '0' : timeList[0].time
              }}{{ timeList[0].suf }}
            </span>
          </div>
          <ul>
            <li v-for="(item, index) in timeList.slice(1)" :key="index">
              <span
                class="living-before__time2"
                v-for="(item2, index2) in item.time"
                :key="index2"
              >
                {{ item2 }}
              </span>
              <span
                v-if="index + 1 != timeList.slice(1).length"
                style="font-size: .65rem;color: #fff;margin-right:.17rem"
              >
                :
              </span>
            </li>
          </ul>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
const completeTime = time => {
  return (time + '').padStart(2, '0') || '00';
};
const getCountdownTime = time => {
  let dayTime = 1000 * 60 * 60 * 24;
  if (time > 0) {
    let date = new Date(time);
    return [
      {
        time: completeTime(Math.floor(time / dayTime)),
        suf: '天'
      },
      {
        time: completeTime(date.getUTCHours()),
        suf: '时'
      },
      {
        time: completeTime(date.getMinutes()),
        suf: '分'
      },
      {
        time: completeTime(date.getSeconds()),
        suf: '秒'
      }
    ];
  }
};
export default {
  name: 'LivingBefore',
  inject: ['livingStore'],
  data() {
    return {
      timer: null,
      timeList: [{}] // {time,suf}
    };
  },
  components: {},
  watch: {
    liveStartTime: {
      handler(v) {
        v && this.setCountdownInterval();
      },
      immediate: true
    }
  },
  computed: {
    liveStartTime() {
      return this.livingStore.detail.liveStartTime;
    },
    isShowCountdown() {
      return this.livingStore.livingConf.isShowCountdown;
    },
    videoPicUrl() {
      return this.livingStore.detail.videoPicUrl;
    },
    countdownPosition() {
      return this.livingStore.livingConf.countdownPosition;
    },
    videoPlaceholder() {
      return this.livingStore.livingConf.placeholder || '距直播开始';
    }
  },
  methods: {
    setCountdownInterval() {
      this.timer = setInterval(() => {
        let difference = this.liveStartTime - Date.now(); // 开始时间与当前时间差
        let differenceByByforecast =
          this.liveStartTime - 1000 * 60 * 10 - Date.now(); // 开始时间与当前时间差,使用预告开始时间
        if (differenceByByforecast > 0) {
          this.timeList = getCountdownTime(difference);
        } else {
          clearInterval(this.timer);
          this.$store.dispatch('living/setCourseDetail', this.$route.params.id); // 计时完成重新拉取数据
        }
      }, 1000);
    }
  },

  beforeDestroy() {
    this.timer && clearInterval(this.timer);
  }
};
</script>

<style scoped lang="scss">
$--height: 5.63rem;
$--width: 10rem;
.living-before {
  position: relative;
  width: $--width;
  height: $--height;
  &__pic {
    width: $--width;
    height: $--height;
  }
  &__top {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 1.07rem;
    background: rgba(0, 0, 0, 0.64);
    // border-radius: 0.22rem 0.22rem 0px 0px;
    color: #d2d2d8;
    font-size: 0.43rem;
    display: flex;
    align-items: center;
    justify-content: center;
    p {
      -webkit-background-clip: text;
    }
    ul {
      display: flex;
      align-items: center;
      margin-left: 0.37rem;
      li {
        span:last-child {
          color: #a9a9ae;
          -webkit-background-clip: text;
        }
      }
    }
  }
  &__full {
    width: $--width;
    height: $--height;
    background: rgba(0, 0, 0, 0.64);
    border-radius: 0.22rem;
    position: absolute;
    top: 0;
    left: 0;
    ul {
      display: flex;
      align-items: center;
      justify-content: center;
      li {
        span {
          line-height: 1;
          color: #ffffff;
        }
      }
    }
  }
  &__mid {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    width: 80%;
  }
  &__top2 {
    display: inline-block;
    padding: 0.22rem 0.74rem;
    background: #3667ec;
    border-radius: 0.16rem;
    color: #ffffff;
    font-size: 0.42rem;
    margin-bottom: 0.32rem;
  }
  &__time2 {
    display: inline-block;

    font-size: 0.54rem;
    font-weight: 500;

    padding: 0.21rem 0.16rem;
    border-radius: 0.16rem;
    margin-right: 0.06rem;
    background: linear-gradient(180deg, #6f7179 0%, #3c3d44 48%, #51545e 100%);
    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
